import Head from "next/head";
import Category from "../components/category-tile/category-tile";
import FrontProducts from "../components/front-products/front-products";
import gravelBikeImage from "./../assets/gravelbike.avif";
import runningImage from "./../assets/running.avif";
import supImage from "./../assets/sup.avif";
import treningImage from "./../assets/trening.avif";
import styles from "./index.module.css";
import cargoBike from "./../assets/cargobike_kopi.avif";
import Link from "next/link";
export default function Home() {
  return (
    <>
      <Head>
        <link rel="canonical" href="https://sportsam.no" />
      </Head>
      <div
        className={styles.container}
        style={{ zIndex: 1001, initialLetter: 1 }}
      >
        <main>
          <Link href="/produkter/lastesykkel">
            <div className={styles.topIndexImg} style={{ backgroundImage: `url(${cargoBike.src})` }}>
              <span className={styles.heroEyebrow}>Prisoversikt for sportsutstyr</span>
              <strong>Finn utstyr som får deg videre.</strong>
              <span className={styles.heroDescription}>Et stort utvalg lastesykler fra flere leverandører.</span>
              <span className={styles.heroCta}>Se lastesykler <span aria-hidden="true">&rarr;</span></span>
            </div>
          </Link>
          <section>
            <div className={styles.sectionHeading}>
              <span>Utforsk</span>
              <h2>Populære kategorier</h2>
            </div>
            <div className={styles.categoryWrapper}>
              <Category
                route={"/produkter/sup"}
                imageUrl={supImage.src}
                header="SUP"
                text="Standup paddleboard til sommeren"
              />
              <Category
                route={"/produkter/lopesko"}
                imageUrl={runningImage.src}
                header="Løpesko"
                text="Et stort utvalg løpesko"
              />
              <Category
                route={"/produkter/gravel"}
                imageUrl={gravelBikeImage.src}
                header="Gravel"
                text="Sykler for by og terreng"
              />
              <Category
                route={"/produkter/etter-trening"}
                imageUrl={treningImage.src}
                header="Etter trening"
                text="Få maksimalt utbytte"
              />
            </div>
          </section>
          <br />
          <FrontProducts />
        </main>
        <br />
        <div className="showInMobile ad" style={{ marginTop: "32px" }}>
          <a
            href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=87143"
            target="_blank"
            rel="nofollow noopener"
          >
            <img
              src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=87143"
              alt="Paddleboard"
            />
          </a>
        </div>
      </div>
    </>
  );
}
